import { render, staticRenderFns } from "./NocMappings.vue?vue&type=template&id=1f4d82c3&scoped=true"
import script from "./NocMappings.vue?vue&type=script&lang=js"
export * from "./NocMappings.vue?vue&type=script&lang=js"
import style0 from "./NocMappings.vue?vue&type=style&index=0&id=1f4d82c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d82c3",
  null
  
)

export default component.exports